import axios from "axios";
import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fetch the current global online-booking flag from the backend.
 * Returns true/false. On error, defaults to true (fail-open) so a backend
 * blip doesn't lock out all customers; the backend re-check right before
 * the Zoho redirect is the authoritative gate.
 */
export const fetchBookingStatus = async () => {
  try {
    const { data } = await axios.get(`${API}/booking-status`, { timeout: 8000 });
    return !!data?.online;
  } catch {
    return true;
  }
};

/**
 * React hook: live booking status. `online` is `null` while loading.
 */
export const useBookingStatus = () => {
  const [online, setOnline] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const value = await fetchBookingStatus();
      if (!cancelled) setOnline(value);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { online, loading: online === null };
};
